<template>
  <select class="klickart-select" style="width: 97%;">
    <option value="">0 - {{ $t('edit.canvas.all_steps') }}</option>
    <option
      v-for="step in stepList"
      :value="step.id"
      :selected="step.id === stepActive.id">{{ `${stepDisplayPosition(step)} - ${step.sanitized_title}` }}</option>
  </select>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import $ from 'jquery';
import 'select2';

export default {
  mounted() {
    $(this.$el)
      .val('')
      .select2()
      .on('change', () => {
        const id = this.$el.value;
        const step = this.stepList.find(step => step.id === id);

        this.stepSetPreview(step);
        this.canvasDisableHighlight();
        this.sidebarChangePanel('style');
      });
  },
  computed: mapGetters({
    stepList: 'stepList',
    stepDisplayPosition: 'stepDisplayPosition',
    stepActive: 'stepActive',
  }),
  methods: mapActions([
    'stepSetPreview',
    'canvasDisableHighlight',
    'sidebarChangePanel',
  ]),
};
</script>



/** WEBPACK FOOTER **
 ** StepSelect.vue?0c5b0dd0
 **/